custom.gtmDatalayer = (() => {
  // push events to data layer for GTM -- remove soon, these may be interfering with other events.
  function gtmPush(data) {
    const dataLayer = window.dataLayer || [];
    if (typeof dataLayer !== 'undefined') {
      if (!data.event) data.event = 'GAEvent';
      // dataLayer.push(data)
    } else {
      //console.log(data)
    }
  }

  // push events to data layer for GTM -- new format and will be over
  function gtmPushNew(data, eventName = 'GAEvent') {
    const dataLayer = window.dataLayer || [];
    if (typeof dataLayer !== 'undefined') {
      if (data.ecommerce && data.ecommerce.items) {
        data.ecommerce.items = data.ecommerce.items.map((item) => {
          let newItem = { ...item };
          if (item.item_brand) {
            if (item.item_brand === '') {
              delete newItem.item_brand;
            } else {
              newItem.item_brand = custom.utils.titleCaseWithExceptions(
                item.item_brand,
              );
            }
          }
          if (item.item_collaboration) {
            if (item.item_collaboration === '') {
              delete newItem.item_collaboration;
            } else {
              newItem.item_collaboration = custom.utils.titleCaseWithExceptions(
                item.item_collaboration,
              );
            }
          }
          if (item.item_color) {
            if (item.item_color === '') {
              delete newItem.item_color;
            }
          }
          if (item.item_name) {
            newItem.item_name = item.item_name.toUpperCase();
          }
          return newItem;
        });
      }
      const sendData = Object.assign({ event: eventName }, data);
      dataLayer.push(sendData);
    } else {
      //console.log(data)
    }
  }

  function gtmPushElem(elem) {
    const data = {
      eventCategory: elem.data('category'),
      eventAction: elem.data('action'),
      eventLabel: elem.data('label'),
    };
    gtmPush(data);
  }

  // fix string to make spaces dashes and all lowercase
  function vanitizeString(input) {
    if (typeof input === 'string') {
      return input.toLowerCase().replace(/ /g, '-');
    }
    return input;
  }

  return {
    gtmPush,
    gtmPushNew,
    gtmPushElem,
    vanitizeString,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/gtm-datalayer.js